import React, { useState, useEffect } from "react";
import { MultilineTitle } from "../../molecules";
import { Logo2, Title } from "../../atoms";
import moment from "moment";
import MenuBar from "../SideBar/SideBar";
import { AnalyticsService } from "../../../utils/Analytics";
import { Stack } from "@mui/material";
import { Button, Grid } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import Select from "react-select";
import Modal from "react-responsive-modal";
import {GETUSERS,VIEWASUSER } from "../../../api/apiConfig";
import { apiGet, apiPost } from "../../../utils";
export const AppHeader = ({ Signout }) => {
  const [time, setTime] = useState(moment().format("h:mm a"));
  const userName = localStorage.getItem("userName");
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })
  const [xSwitch, setXSwitch] = useState({value:"1",label:localStorage.getItem("xSwitch")});
  const [isAdmin,setIsAdmin] =useState(localStorage.getItem("roleId")=="1")
  const [increaseHeight,setIncreaseHeight]=useState(false)
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [menu, setMenu] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const openMenu = () => {
    setMenu(true);
    AnalyticsService.logEvent("MOBILE_MENU_OPEN");
  };
  const onClose = () => {
    setMenu(false);
    AnalyticsService.logEvent("MOBILE_MENU_CLOSE");
  };
  useEffect(() => {
    isAdmin && users.length==0 && getUserList();
    setInterval(() => {
      setTime(moment().format("h:mm a"));
    }, 1000);

    return () => {
      setTime("");
    };
  }, []);

  const userList =
  users &&
  users.map((m) => ({
    value: m.id,
    label: m.name,
  }));
  
  
  const getUserList = async () => {
    const res = await apiGet(GETUSERS);
    if (res) {
      setUsers(res)
      var user=res.filter(x=>x.id==localStorage.getItem("id"))[0]
      setXSwitch({value:"1",label:user?.xSwitch});
      localStorage.setItem("xSwitch", user?.xSwitch);
      setIsAdmin(user.role==1);
    }
  };

  function SelectUser(){
    const action = async () => {
      const res = await apiPost(`${VIEWASUSER}`, {Name: xSwitch?.label});
      console.log("res", res);
      if (res) {
        AnalyticsService.logEvent("User_Chosen");
        localStorage.setItem("xSwitch", xSwitch?.label);
        setOpen(false)
        window.location.reload();
      }
    };    
    return (
      <Modal style={{width:'unset'}} open={open} showCloseIcon={true} center onClose={onCloseModal}>
        <div className="padding">
          <div className="text bold lg space-bottom2">Select Merchant</div>
          <div className="text sm space-bottom2">Please select the merchant you want to open as</div>
          <Grid container spacing={2} style={{minHeight:increaseHeight?"380px":"auto",width:'100%'}}>
              <Grid item xs={12} id="categorySelection" style={{width:'100%',fontFamily:"Helvetica"}} >
          <Select
          
            onMenuOpen={()=>setIncreaseHeight(true)}
            onMenuClose={()=>setIncreaseHeight(false)}
            placeholder={"Please select"}
            onChange={(option) => setXSwitch(option)}
            options={userList}
            value={xSwitch}
            defaultValue={userList ? userList[0] : undefined}
            isSearchable={true}
          />
          </Grid>
          </Grid>

          <div className="push-right space-top">
            <Stack direction={"row"} spacing={2}>
              <Button variant="contained" sx={{background:"#000"}} onClick={()=>setOpen(false)}>Close</Button>
              <Button variant="contained" sx={{background:"#4E9D24"}} onClick={()=>action()}>Proceed</Button>
            </Stack>

          </div>
        </div>
      
      </Modal>
    )
  }

  return (
    <div className="appHeaderSec">
      <div className="flexD">
        <MenuBar onSignout={Signout} />
        <div className="logoAndLeftHeader">
          <Logo2 className={"header-logo"} />

          <div className={`multiSec leftHeader `} >
              <Stack direction={"row"} spacing={2} className="center">
                {(xSwitch?.label==null || !isAdmin) &&
                  <Title className={"headerTxtUprLeft nowrap"} text={userName} />
                }
                {(isAdmin) &&
                (
                <span onClick={()=>isAdmin && setOpen(true)} className="black headerTxtUprLeft nowrap ruby center click">
                  
                  {xSwitch?.label}
                </span>
                )}
              </Stack>
              <Title className={"headerTxtBtmLeft nowrap"} text={"Orders"} />
          </div>
          
          {/* <MultilineTitle
            upperText={isAdmin?xSwitch?.label:userName}
            bottomText={`Orders`}
            upperClsName={"headerTxtUprLeft nowrap"}
            bottomClsName={"headerTxtBtmLeft nowrap"}
            boxClsName={"leftHeader"}
          /> */}
        </div> 
      </div>
      {!isTabletOrMobile &&
      <Stack spacing={0.5} style={{width:'100%',opacity:'.5'}}>
        <hr style={{borderTop:"dashed 2px #E3031F",borderBottom:'none',marginBottom:'-0.5px'}}/>
        <hr style={{borderTop:"solid 2px #E3031F",borderBottom:'none'}}/>
        <hr style={{borderBottom:"dashed 2px #E3031F",borderTop:'none'}}/>
      </Stack>}
      <div className="d-sm-flex d-none">
        <MultilineTitle
          upperClsName={"headerTxt"}
          bottomClsName={"underLineText"}/> 
        <MultilineTitle
          upperText={moment().format("Do MMM YYYY")}
          bottomText={time}
          upperClsName={"headerTxt"}
          bottomClsName={"headerTxt"}
          boxClsName={"headerBoxRight"}
        /> 
      </div>
      {isAdmin && SelectUser()}
    </div>
  );
};
